import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider, useToastContext } from './contexts/ToastContext';
import { PresenceProvider } from './contexts/PresenceContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppRoutes } from './router';
import { useIdleTimer } from './hooks/useIdleTimer';
import { useCallback } from 'react';

declare const __BASE_PATH__: string;

function AppContent() {
  const { userProfile, signOut } = useAuth();
  const { success } = useToastContext();

  const idleTimeoutMinutes = userProfile?.perfil?.tempo_sessao_minutos;

  const handleIdle = useCallback(() => {
    signOut();
    success('Sessão expirada', 'Sua sessão foi encerrada por inatividade.');
  }, [signOut, success]);

  useIdleTimer({
    onIdle: handleIdle,
    idleTime: idleTimeoutMinutes ? idleTimeoutMinutes * 60 * 1000 : 0,
  });

  return <AppRoutes />;
}

function App() {
  return (
    <BrowserRouter basename={typeof __BASE_PATH__ !== 'undefined' ? __BASE_PATH__ : '/'}>
      <AuthProvider>
        <PresenceProvider> {/* Movido para cá */}
          <ToastProvider>
            <ThemeProvider>
              <AppContent />
            </ThemeProvider>
          </ToastProvider>
        </PresenceProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;